import IndividualNavbar from "../IndividualNavbar/IndividualNavbar";
import ProjectsContent from "../ProjectsContent/ProjectsContent";

import styles from './ProjectsPage.module.css';

export default function ProjectsPage() {
    return (
        <main>
            <section id="nav-bar">
                <IndividualNavbar data-testid="individual-navbar" />
            </section>

            <section id={styles['projects-content']}>
                <ProjectsContent data-testid="projects-content" />
            </section>
        </main>
    );
}